import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useStripe } from '@stripe/react-stripe-js';

import Notification from '../../../../components/Notification/Notification';
import urls from '../../../../routing/urls';

const PaymentStatus = () => {
  const { t } = useTranslation('common');
  const stripe = useStripe();
  const navigate = useNavigate();

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get('setup_intent_client_secret');

    stripe.retrieveSetupIntent(clientSecret).then(({ setupIntent }) => {
      switch (setupIntent.status) {
        case 'succeeded':
          Notification.success(t('payments.successSaved'));
          break;

        case 'processing':
          Notification.success(t('payments.processingDetails'));
          break;

        case 'requires_payment_method':
          Notification.error(t('payments.failedToProcess'));
          break;

        default:
          Notification.error(t('payments.somethingWentWrong'));
          break;
      }
      navigate(urls.payments);
    });
  }, [stripe, t]);

  return null;
};

export default PaymentStatus;
